import generateRender from 'shared/utils/generateRender';
import DefaultDOBInputs from './DateOfBirth/DefaultDOBInputs';

const DOBInputs = generateRender({
  default: DefaultDOBInputs,
});

export default DOBInputs;

